import { useState } from 'react';

const usePagination = (list: any[], pageSize?: number) => {
  const [data, setData] = useState(list);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = pageSize ?? data.length;
  const maxPage = Math.ceil(data.length / itemsPerPage);

  const currentData = () => {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  };

  const next = () => {
    setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
  };

  const prev = () => {
    setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
  };

  const jump = (page: number) => {
    const pageNumber = Math.max(1, page);
    setCurrentPage(currentPage => Math.min(pageNumber, maxPage));
  };

  const count = Math.ceil(data.length / itemsPerPage);

  return { count, currentPage, maxPage, setCurrentPage, setData, next, prev, jump, currentData };
};

export default usePagination;
